'use strict';

import casosPCD from './casosPCD.component'
import './casosPCD.css'

const CasosPCDModule = angular
  .module('app.casosPCD', [])
  .component('casosPCD', casosPCD)
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('casosPCD', {
        url: '/soporte_casos_pcd',
        component: 'casosPCD'
      });
    $urlRouterProvider.otherwise('/');
  })
  .name;

export default CasosPCDModule



// WEBPACK FOOTER //
// ./src/app/components/soporte/casosPCD/casosPCD.module.js